var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(_vm.getMode === 'filmpiraten' ? ' ' : '') +
        (_vm.selected && !_vm.isMobileDevice ? 'uk-dark-card-selected ' : '') +
        '  uk-height-1-1 uk-padding-small select-item uk-card cursor-pointer ' +
        (_vm.isMobileDevice
            ? 'uk-dark-card-select'
            : 'uk-dark-card-select-hover')},[_c('div',{class:_vm.slim ? '' : 'uk-text-center uk-padding-very-small'},[(_vm.icon)?_c('span',{attrs:{"uk-icon":'icon: ' + _vm.icon + '; ratio: 2'}}):_vm._e(),_c('div',{class:_vm.slim ? '' : 'product-name',domProps:{"innerHTML":_vm._s(_vm.name)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }